import React, { useState, useRef, useEffect } from "react";
import useAppAccessor from "../../../../hooks/useappAccessor";
import Message from "../../constants";
import { No_Chat } from "../../../../assets/icons";
import { getBrandColor } from "../../../../utils/brand.util";
const MessageItem = ({
  messages,
  userConnect,
  memberJoin,
  memberLeft,
}: any) => {
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const [countMember, setCountMember] = useState<any>([]);
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { allAttendeeList } = getLiveMainData();
  const { user, client } = getUserData();
  const { publicUserData } = user;
  const { language } = getUserData();

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const isShortHeightDevice = isMobile && window.innerHeight < 700;

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages.length]);

  useEffect(() => {
    setCountMember((prevCountMembersLeft: any) => [
      ...prevCountMembersLeft,
      memberLeft,
    ]);
  }, [memberJoin]);

  const truncateFullNameCrm = (given_name: string, family_name: string) => {
    if (userConnect?.name?.match(/[a-zA-Z]+/g).length >= 4) {
      const newName = given_name + " " + family_name;
      const newdata = newName.split(" ");
      return newdata[newdata.length - 1] + " " + newdata[0];
    } else {
      return userConnect?.name;
    }
  };


  return (
    <div
      ref={messagesContainerRef}
      className="pb-5 chatbox--messages overflow-auto chatbox--messages--pd-active"
      style={{
        maxHeight: !isMobile 
          ? "calc(100vh - 6rem - 76px)" 
          : isShortHeightDevice 
            ? "calc(30vh)" 
            : "calc(45vh)",
        overflowY: "auto",
        overflowX: "hidden",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {messages && Array.isArray(messages) && messages.map((message: any, index: any) => {
        var attendee = allAttendeeList.find(
          (attendee: any) => attendee?.uid === message.uid
        );
        if (attendee != null)
          return (
            <>
              <div className="flex w-full p-1.5" key={index}>
                <div
                  className="rounded-full flex items-center justify-center text-white flex-shrink-0"
                  style={{
                    cursor:'default',
                    height: 40,
                    width: 40,
                    backgroundColor: getBrandColor(client),
                  }}
                >
                  {attendee?.avatar &&
                  attendee?.avatar.length > 0 &&
                  !attendee?.avatar.includes("default_avatar.png") ? (
                    <img
                      style={{ borderRadius: "50%", height: 40, width: 40 }}
                      src={attendee.avatar}
                    />
                  ) : (
                    <span className="text-base text-white font-medium">
                    {attendee?.firstName && attendee?.lastName
                    ? `${Array.from(attendee.firstName)[0] || ""}${Array.from(
                        attendee.lastName
                      )[0] || ""}`
                    : ""}
                    </span>
                  )}
                </div>

                <div
                  key={index}
                  className=" w-full pt-1 pb-1 pl-2 pr-2 ml-3 rounded"
                  style={{ minWidth: "100px" }}
                >
                  <div className="flex">
                    <p className="text-white text-xs font-semibold">
                      {attendee.firstName + " " + attendee.lastName}
                    </p>
                    {/* <p
                    style={{ color: "#E0DCDC" }}
                    className="ml-2 pt-1 text-white text-sm text-lg"
                  >
                    {message.createAt}
                  </p> */}
                  </div>
                  <p
                    style={{ color: "#E0DCDC", overflowWrap: "break-word" }}
                    className="text-white  pt-1 text-xs"
                  >
                    {message.text} {message.emoji}
                  </p>
                </div>
              </div>
              {/* <div className="text-white text-xs opacity-30 text-right mr-5">
                {message?.createAt}
              </div> */}
            </>
          );
      })}
      {/* {messages.length === 0 && (
        <>
          {isMobile && (
            <p className="text-white text-center" style={{ opacity: 0.7 }}>
            Slide down to close.
          </p>
          )}
        </>
      )} */}

  {
    messages?.length === 0 && 
    <div
    style={isMobile ? {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop:'155px',
    } : {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop:'225px',
    }}
  >
    {messages?.length === 0 && (
      <>
        <img src={No_Chat} className="mx-auto mt-10" style={{height: 74}}></img>
        <div style={{width:'269px', textAlign:'center', marginTop:'10px'}}>
          <p style={{color:'#DEDEDE', fontSize:'16px', fontWeight:'400', lineHeight:'28px'}}>{language['no_msg']}..</p>
        </div>
      </>
    )}
  </div>
  }
     
    </div>
  );
};

export default MessageItem;
